// SEO configurations — optimized for "reggaeton bruxelles / brussels / bruselas" queries
// Multi-language keywords packed for maximum reach (FR + NL + EN + ES all matter in Brussels)
const currentYear = new Date().getFullYear();
const nextOpenAirYear = 2026;

export const seoConfig = {
  home: {
    title: `Reggaeton Bruxelles · Bruselas | Invasion Latina · Fiesta Latina ${currentYear}`,
    description: `La plus grande soirée reggaeton de Bruxelles depuis 2009. La fiesta latina más grande de Bélgica. Eventos en Mirano Continental + Open Air ${nextOpenAirYear} Place du Congrès. Reggaeton, latin trap, dembow, bachata. Bruxelles · Brussels · Bruselas.`,
    keywords: "reggaeton bruxelles, reggaeton bruselas, reggaeton brussels, reggaeton belgique, fiesta latina bruselas, fiesta reggaeton bruselas, discoteca latina bruselas, donde bailar reggaeton bruselas, salir bruselas reggaeton, eventos latinos belgica, soirée latino bruxelles, soirée reggaeton bruxelles, latin party brussels, latino feest brussel, open air reggaeton bruxelles, open air bruselas 2026, invasion latina, mirano continental, place du congrès, fête latine bruxelles, latin trap bruxelles, bachata bruxelles, bachata bruselas, dembow bruxelles",
    canonical: "/"
  },

  agenda: {
    title: `Prochaines Soirées Reggaeton Bruxelles — Agenda ${currentYear} | Invasion Latina`,
    description: `Agenda des prochaines soirées reggaeton à Bruxelles : events mensuels Mirano Continental + Open Air ${nextOpenAirYear}. Prochaine fiesta latina à Bruselas. Achète tes tickets maintenant.`,
    keywords: "prochaine soirée reggaeton bruxelles, agenda reggaeton brussels, agenda latino bruxelles, prochaine fiesta latina bruselas, calendrier invasion latina, mirano agenda, open air bruxelles agenda, prochaines soirees latines belgique",
    canonical: "/agenda"
  },

  histoire: {
    title: `Histoire Invasion Latina — ${currentYear - 2009} ans de Reggaeton à Bruxelles`,
    description: `Invasion Latina depuis 2009 : l'histoire de LA soirée reggaeton et latino à Bruxelles. +1 200 events, +240 000 tickets vendus, la plus grande communauté latina de Belgique.`,
    keywords: "histoire invasion latina, meilleure soirée latina bruxelles, plus grande soirée reggaeton belgique, invasion latina depuis 2009, reggaeton bruxelles histoire, latino brussels since 2009",
    canonical: "/histoire"
  },

  videos: {
    title: "Aftermovies Reggaeton Bruxelles — Invasion Latina Videos",
    description: "Revis les meilleurs moments d'Invasion Latina : aftermovies Open Air Bruxelles, teasers Mirano Continental, ambiance reggaeton et latin trap. Brussels latin nightlife videos.",
    keywords: "aftermovie invasion latina, video reggaeton bruxelles, teaser open air bruxelles, reggaeton video belgium, latin party video brussels, aftermovie mirano continental",
    canonical: "/videos"
  },

  galerie: {
    title: "Photos Soirée Reggaeton Bruxelles — Galerie Invasion Latina",
    description: "Galerie photos officielles : Open Air Bruxelles, soirées Mirano Continental, reggaeton parties brussels. La plus grande communauté latina de Belgique en images.",
    keywords: "photos invasion latina, galerie soirée reggaeton bruxelles, photos open air bruxelles, images reggaeton belgium, photos fiesta latina bruselas",
    canonical: "/galerie"
  },

  ideologie: {
    title: "Safe Space Reggaeton Bruxelles — Valeurs Invasion Latina",
    description: "Invasion Latina, c'est une communauté fondée sur le respect, la sécurité et la familia. Découvrez notre charte : zéro harcèlement, inclusivité, safe space à Bruxelles.",
    keywords: "safe space bruxelles, soirée safe bruxelles, valeurs invasion latina, respect soirée latina, inclusivité fiesta latina, charte reggaeton bruxelles",
    canonical: "/ideologie"
  },

  experience: {
    title: "Open Air Reggaeton Bruxelles — L'Expérience Invasion Latina",
    description: "7 000 personnes, 8h de reggaeton non-stop, 7 DJs, le meilleur sound system de Belgique. Open Air à la Place du Congrès. Plus qu'une soirée, une familia.",
    keywords: "open air reggaeton bruxelles, open air latin bruxelles, festival reggaeton bruxelles, festival latin belgique, reggaeton plein air bruxelles, place du congres event",
    canonical: "/experience"
  },

  booking: {
    title: "Table VIP Reggaeton Bruxelles — Réservation Invasion Latina",
    description: "Réserve ta table VIP pour Invasion Latina : service premium, bouteilles, zone réservée. Open Air Place du Congrès ou Mirano Continental Bruxelles.",
    keywords: "table vip reggaeton bruxelles, réservation vip bruxelles, table open air, bouteille vip mirano, vip booking latino bruxelles, reserve vip latin party brussels",
    canonical: "/booking"
  },

  app: {
    title: "App Invasion Latina — Reggaeton Bruxelles iOS & Android",
    description: "Télécharge l'app Invasion Latina : tickets reggaeton Bruxelles, Invasion Coins, song requests au DJ, agenda des soirées. iOS + Android.",
    keywords: "app invasion latina, application reggaeton bruxelles, invasion coins, latin party app brussels, app soirée latina bruselas",
    canonical: "/app"
  }
};
